import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

import { CheckIcon, Fade } from 'ui/chandra'

const BoxContainer = styled('div')`
  position: absolute;
  top: -10px;
  right: -10px;
  height: 24px;
  width: 24px;
  background: #ffffff;
  border-radius: 50%;
`

const Selected = ({ selected }) => (
  <Fade inTrigger={selected} appear={true}>
    <BoxContainer>
      <CheckIcon selected={true} />
    </BoxContainer>
  </Fade>
)

Selected.propTypes = {
  selected: PropTypes.bool.isRequired
}
export default Selected
